export default __webpack_public_path__ + "static/media/information--end-of-built-up-area--g3.d59cc0fb.png";